/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Physical_Modalities_TermsInputs */

const en_service_type_physical_modalities_terms = /** @type {(inputs: Service_Type_Physical_Modalities_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`laser, electrotherapy, tens, ultrasound, magnetic therapy, cryotherapy`)
};

const pl_service_type_physical_modalities_terms = /** @type {(inputs: Service_Type_Physical_Modalities_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`laser, laseroterapia, elektroterapia, tens, ultradźwięki, magnetoterapia, krioterapia, prądy`)
};

/**
* | output |
* | --- |
* | "laser, electrotherapy, tens, ultrasound, magnetic therapy, cryotherapy" |
*
* @param {Service_Type_Physical_Modalities_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_physical_modalities_terms = /** @type {((inputs?: Service_Type_Physical_Modalities_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Physical_Modalities_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_physical_modalities_terms(inputs)
	return en_service_type_physical_modalities_terms(inputs)
});